type Environment = "local" | "dev" | "prod" | "qa";

class AppConfig {
    version: string | null = null;
    environment: Environment | null = null;
    gaTrackingCode: string | null = null;
    gtmTrackingCode: string | null = null;

    initalizeAppConfig({
        version,
        environment,
        gaTrackingCode,
        gtmTrackingCode,
    }: {
        version: string;
        environment: Environment;
        gaTrackingCode: string;
        gtmTrackingCode: string;
    }) {
        this.version = version;
        this.environment = environment;
        this.gaTrackingCode = gaTrackingCode;
        this.gtmTrackingCode = gtmTrackingCode;
    }
}

export const appConfig = new AppConfig();
